import { LOADING } from '../actions/index';

const INITIAL_STATE = {
  app: false,
  match: false,
  pdf: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        [action.component]: action.loading,
        message: action.message || null,
      };

    default:
      return state;
  }
}
